// extracted by mini-css-extract-plugin
export default {"cls1":"VeloResponsiveText-Desktop_cls1__wnwEO","cls2":"VeloResponsiveText-Desktop_cls2__-g8XJ VeloResponsiveText-Desktop_cls1__wnwEO"};